import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/lib/lenis";
import { NAV_IDS, ADDRESS, PHONE_DISPLAY } from "@/lib/constants";
import { useLang } from "@/lib/i18n";
import logo from "@/assets/logo.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden text-ivory">
      <div className="texture-toile absolute inset-0" aria-hidden="true" />
      <div className="absolute inset-0 bg-bordeaux/85" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
          <div>
            <img src={logo} alt="Gelateria Imperiale" data-testid="footer-logo" className="h-28 w-auto sm:h-32" />
            <p className="mt-3 font-mono-alt text-[11px] uppercase tracking-[0.3em] text-ivory/70">
              {t.footer.tagline}
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/70">
              {ADDRESS} · {PHONE_DISPLAY}
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-12 gap-y-3">
            {NAV_IDS.map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToSection(id)}
                className="text-left font-mono-alt text-[11px] uppercase tracking-[0.22em] text-ivory/80 transition-colors hover:text-ivory"
              >
                {t.nav[id]}
              </button>
            ))}
          </nav>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-ivory/20 pt-6 sm:flex-row sm:items-center">
          <p className="font-mono-alt text-[10px] uppercase tracking-[0.25em] text-ivory/50">{t.footer.rights}</p>
          <Link
            data-testid="footer-admin-link"
            to="/admin"
            className="inline-flex items-center gap-2 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-ivory/50 transition-colors hover:text-ivory"
          >
            <Lock className="h-3.5 w-3.5" /> {t.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
}
